<template>
	<b-row v-if="page === 'project'">
		<b-col cols="12" class="p-md-3 p-0">
			<div>
				<hooper :settings="settings.main" class="project-main text-center" ref="projectHooperSlider" v-on:slide="updateCarousel" group="g1">

					<slide v-for="(img, idx) in items" :key="idx" :index="idx"  class="hooper-slide mx-auto text-center position-relative">
						<img :alt="img" :src="img" class="mw-100 mh-100 position-absolute">
					</slide>

			      	<hooper-navigation slot="hooper-addons">
						<img slot="hooper-prev" :src="assets_url+ 'img/SetaProjeto_Esq.png'">
						<img slot="hooper-next" :src="assets_url+ 'img/SetaProjeto_Dta.png'">
					</hooper-navigation>
			      	<hooper-pagination slot="hooper-addons"></hooper-pagination>

				</hooper>
			</div>
		</b-col>
		<div class="container">
			<b-row>
				<b-col cols="12">
					<div  class="mt-5 text-center">
						<hooper group="g1" :settings="settings.synced" class="synced">

							<slide v-for="(img, idx) in items" :key="idx" :index="idx" v-on:click.native="$refs.projectHooperSlider.slideTo(idx)" :class="(current_slide === idx) ? 'line-up-dark' : ''" class="hooper-slide cursor-pointer p-2">

								<div :style="'background-image: url(' +img+ ');'" class="inner-slide h-100"></div>

							</slide>

						</hooper>
					</div>
				</b-col>
			</b-row>
		</div> 
  </b-row>
  <b-row v-else-if="page === 'investors'">
  		<div class="container">
			<b-row>
				<b-col cols="12">
					<div  class="mt-2 mt-md-4 text-center">
						<hooper :settings="settings" class="investors-main mx-auto" :class="settings.main_class" ref="investorsHooperSlider" v-on:slide="updateCarousel">

							<slide v-for="(item, idx) in items" :key="idx" :index="idx" class="hooper-slide cursor-pointer investors" v-on:click.native="$refs.investorsHooperSlider.slideTo(idx)">
								
								<a :href="item.href" target="_blank" class="d-block border-slide h-100 m-1" :class="(current_slide === idx) ? 'investors-selected' : ''">
									<div class="inner-slide up position-relative h-50 pt-1" :class="(current_slide === idx) ? 'investors-selected' : ''">
										<p class="section-title mb-1" :style="(item.name.length > 26) ? 'font-size: 8px; line-height: 12px;' : ''">{{item.name}}</p>
										<div class="position-absolute w-100 year-label">
											<hr class="m-0 mx-auto w-25">
											<p class="section-title mt-1 m-0" :style="(item.name.length > 26) ? 'font-size: 8px; line-height: 12px;' : ''">{{item.year}}</p>
										</div>
									</div>
									<div class="inner-slide down h-50 text-white">
										<p class="p-1 m-0">
											<div class="ani_icon text-center slider-down">
							                    <div class="slide-1">
							                        <img class="d-inline-block" alt="Seta_Download_3.png" src="../assets/images/Seta_Download_4.png">
							                    </div>
							                    <div class="slide-2">
													<img class="d-inline-block" alt="Seta_Download_3.png" src="../assets/images/Seta_Download_4.png">
												</div>
							                </div>
											<span class="d-block section-title download-text">DOWNLOAD PDF</span>
										</p>
									</div>
								</a>
								

							</slide>
							
							<hooper-navigation slot="hooper-addons">
								<img slot="hooper-prev" :src="assets_url+ 'img/SetaInvestors_Esq.png'">
								<img slot="hooper-next" :src="assets_url+ 'img/SetaInvestors_Dta.png'">
							</hooper-navigation>
							<hooper-pagination slot="hooper-addons"></hooper-pagination>

						</hooper>
					</div>
				</b-col>
			</b-row>
		</div>
  </b-row>
</template>
<script>
import { Hooper, Slide, Navigation as HooperNavigation, Pagination as HooperPagination } from 'hooper';
import 'hooper/dist/hooper.css';

export default {
  	components: {
		Hooper,
		Slide,
		HooperNavigation,
		HooperPagination
	},
	props: ['page', 'items', 'settings'],
	data() {
		return {
			current_slide: this.settings.initialSlide,
			assets_url: process.env.VUE_APP_ASSETS_ROOT,
		}
	},
	methods: {
		updateCarousel: function(slide) {
			if(slide.currentSlide === -1)
				this.current_slide = this.items.length - 1;
			else if(slide.currentSlide === this.items.length)
				this.current_slide = 0;
			else
				this.current_slide = slide.currentSlide;
		}
	},
	created() {
		/*console.log(this.settings)*/
	}
}
</script>
<style scoped>
</style>
<style>
	.hooper.synced, .hooper.project-main, .hooper-navigation button {
	   outline:none;
	}
	.hooper.synced::-moz-focus-inner, .hooper.project-main, .hooper-navigation button::-moz-focus-inner {
	   border: 0;
	}

	.hooper.project-main {
		height: 450px;
	}
	.hooper.project-main .hooper-list {
		margin: 0 auto;
	}
	.hooper.project-main .hooper-slide img {
		bottom: 0px;
	    right: 0px;
	    left: 0px;
	    margin: auto;
	}
	.hooper.project-main .hooper-slide, .hooper.synced .hooper-slide .inner-slide, .hooper.investors-main .hooper-slide, .hooper.investors-main .hooper-slide .inner-slide {
		background-size: cover;
		background-repeat: no-repeat;
		background-position: center center;
	}
	.hooper .hooper-pagination {
		background-color: rgba(255, 255, 255, 0.7);
		position: relative;
		right: 0;
		text-align: center;
		-webkit-transform: translateX(0);
		transform: translateX(0);
		display: none;
		padding: 5px 0;
	}
	.hooper.project-main .hooper-pagination {
		bottom: 34px;
	}
	.hooper .hooper-pagination ol {
		text-align: center;
		display: block;
	}
	.hooper .hooper-pagination ol li {
		display: inline-block;
	}
	.hooper.project-main .hooper-next {
		right: 0;
		padding-right: 0;
	}
	.hooper.project-main .hooper-prev {
		left: 0;
		padding-left: 0;
	}
	.hooper .hooper-indicator {
		background-color: #999999;
		height: 8px;
		width: 8px;
		border-radius: 50%;
	}
	.hooper .hooper-indicator.is-active {
		background-color: #00263d;
	}
	.hooper.investors-main .hooper-next {
		right: -52px;
		padding-left: 0;
	}
	.hooper.investors-main .hooper-prev {
		left: -35px;
		padding-left: 0;
	}
	/*.project-selected {
		border: 1px solid #000000;
	}*/
	
	.hooper.investors-main.investors-info {
		width: 85%;
	}
	.hooper.investors-main .hooper-pagination {
		
	}
	.hooper.investors-main.report {
		width: 93%;
	}
	.hooper.investors-main .hooper-list {
		padding-bottom: 4px;
	}
	/*.hooper.investors-main a {
		color: inherit;
	}*/
	.hooper.investors-main a .download-text {
		font-size: 9px;
	}
	.hooper.investors-main .hooper-pagination {
		top: -28px;
	}
	.hooper.investors-main {
		height: 140px;
	}
	.hooper.investors-main .hooper-slide {
		height: 136px;
	}
	.hooper.investors-main .hooper-slide .border-slide {
		border: 2px solid rgba(0, 38, 61, 0.7);
	}
	.hooper.investors-main .hooper-slide .border-slide hr {
		background-color: rgba(0, 38, 61, 0.7);
		height: 3px;
	}
	.hooper.investors-main .hooper-slide .border-slide .year-label {
		left: 0;
		bottom: 1px;
	}
	.hooper.investors-main .hooper-slide .border-slide .up p {
		line-height: 18px;
		font-size: 12px;
	}
	.hooper.investors-main .hooper-slide .border-slide .down p {
		font-size: 10px;
	}
	.hooper.investors-main .hooper-slide:hover a {
		text-decoration: none;
	}
	.hooper.investors-main .hooper-slide .inner-slide.up {
		background-color: rgba(255, 255, 255, 0.7);
		color: rgba(0, 38, 61, 0.7);
	}
	.hooper.investors-main .hooper-slide .inner-slide.down {
		background-color: rgba(0, 38, 61, 0.7);
	}
	.hooper.investors-main .hooper-slide .investors-selected .inner-slide.up {
		background-color: rgba(255, 255, 255, 1);
		color: rgba(0, 38, 61, 1);
	}
	.hooper.investors-main .hooper-slide .investors-selected .inner-slide.down {
		background-color: rgba(0, 38, 61, 1);
	}
	.hooper.investors-main .hooper-slide .border-slide.investors-selected {
		border: 2px solid rgba(0, 38, 61, 1);
	}
	.hooper.investors-main .hooper-slide .border-slide.investors-selected hr {
		background-color: rgba(0, 38, 61, 1);
	}
	.hooper.synced {
		height: 160px;
	}
	.ani_icon {
	    display: inline-block;
	    position: relative;
		width: 100%;
	    height: 28px;
	    overflow: hidden;
	    cursor: pointer;
	}
	.slide-1 {
	    position: absolute;
	    top:0; left:0;
	    height: 100%;
	    width: 100%;
	    transition: all .5s;
	}
	.hooper.investors-main .hooper-slide .border-slide img {
		width: 19px;
	}
	.hooper.investors-main .hooper-slide .border-slide:hover .ani_icon.slider-down .slide-1 { top: 100%; opacity:0; }

	.slide-2 {
	    position: absolute;
	    height: 100%;
	    width: 100%;
	    font-size: 1.2em;
	    transition: all .5s;
	    opacity: 0;
	}

	.ani_icon.slider-down .slide-2 { top: -100%; }


	.hooper.investors-main .hooper-slide .border-slide:hover .ani_icon.slider-down .slide-2 { top: 0; opacity: 1; }
	@media screen and (max-width:991.98px) {
		.hooper.investors-main.report, .hooper.investors-main.investors-info {
			width: 100%;
		}
		.hooper.investors-main .hooper-next, .hooper.investors-main .hooper-prev {
			display: none;
		}
		.hooper.investors-main .hooper-pagination {
			display: block;
		}
		.hooper.investors-main .hooper-list {
			height: 173px;
		}
	}
	@media screen and (max-width:767.98px) {
		.hooper.project-main {
			height: 350px;
		}
		.hooper.project-main .hooper-navigation {
			display: none;
		}
		.hooper.project-main .hooper-list {
			width: 100%;
		}
		.hooper.project-main .hooper-pagination {
			display: block;
		}
		.hooper.synced {
			display: none;
		}
		.hooper.investors-main.report, .hooper.investors-main.investors-info {
			width: 100%;
		}
		.hooper.investors-main .hooper-next, .hooper.investors-main .hooper-prev {
			display: none;
		}
	}
</style>